import React from 'react';

import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import privacy from '../../../config/privacy';
import { saveBook } from '../../../modules/book';
import accessUtil from '../../../utils/accessUtil';
import { authUtil } from '../../../utils';

const PublishingSettings = ({ style = {}, book }) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const userProfile = useSelector((state) => state.user.userProfile);
  const currentBook = useSelector((state) => state.book.currentBook);
  const writing = useSelector((state) => state.book.writing);
  const useBook = book || currentBook;

  const updatePrivacySettings = async event => {
    event.stopPropagation();
    const newPrivacyValue = event.target.value;
    if (newPrivacyValue !== 'unpublished' && useBook.wordCount === 0) {
      return toast.error(
        <Trans i18nKey='BookHas0WordsDescription'>
          <span>
            This book has at least one version with 0 words. You can add or
            upload chapters{' '}
          </span>
          <Link to={`/books/${useBook._id}/content`}>here</Link>.
        </Trans>
      );
    }
    if (newPrivacyValue !== 'unpublished' && useBook.content?.some(v => v.parts?.length && !v.aiDisclosure?.type)) {
      toast.error('Declare AI use for each version in Book details before sharing.');
      return;
    }
    const idToken = await authUtil.getFreshIdToken();
    // only try to save the update if it is bound to work
    dispatch(
      saveBook(idToken, {
        _id: useBook._id,
        privacy: newPrivacyValue,
      })
    );
  };

  return (
    <div style={{ ...style }}>
      <label className='br-field'>
        <span className='br-field__label'>{t('PrivacyLevel')}</span>
        <select className='br-field__input' value={useBook.privacy}
          onChange={updatePrivacySettings}
          disabled={useBook.role !== 'author' &&
            !accessUtil.isAllowed(useBook.access, ['edit'])}>
          {privacy.privacyOptions(useBook._id).map(option => (
            <option key={option.key} value={option.value}>
              {t(`PrivacyLevel_state_${option.value}`)}
            </option>
          ))}
        </select>
      </label>
      <div style={{ fontSize: '0.8em', fontWeight: 'standard', color: 'grey' }}>
        {privacy.get(useBook, 'infoText')}
      </div>
      <p style={{ fontSize: '0.85em', marginTop: '8px' }}>
        Readers must write their own feedback and may not send your manuscript
        to AI services.
      </p>
    </div>
  );
};

export default PublishingSettings;
